import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { User, AnalyticsService, AnalyticsData } from '@icullen/api/shared';
import { UpgradeSubscriptionInfo } from '../subscribe/upgrade-subscription-info.model';

@Component({
  selector: 'document-paywall',
  templateUrl: './paywall.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./paywall.component.scss']
})
export class PaywallComponent implements OnInit {

  @Input() subscriptionInfo: UpgradeSubscriptionInfo;

  constructor( private analyticsService: AnalyticsService,) { }

  ngOnInit(): void {
    //console.log(this.serviceName);
  }

  addAnalyticsEvent(){
    const service=this.subscriptionInfo.service;
    const uniqueNumber=this.subscriptionInfo.uniqueNumber;
    this.analyticsService.pushUpgradeSubscriptionEvent('upgradeSubscriptionButtonClicked',service,uniqueNumber);
  }

}
